<studio-form-label *ngIf="label" [class]="theme" [text]="label"></studio-form-label>
<div [class.text-wrapper]="!isCode">
  <input *ngIf="!isCode" class="text" [title]="text" [value]="text" readonly />
  <ng-container *ngIf="isCode">
    <pre class="snippet-highlighting">
      <code class="code-text" [innerHtml]="codeFormatText(text)"></code>
    </pre>
  </ng-container>
  <div class="actions" [class.inline]="canDownload && !isCode">
    <studio-clipboard-copy
      (copied)="copied.emit($event)"
      [copyText]="text"
      class="copy-button"
    ></studio-clipboard-copy>
    <studio-icon
      *ngIf="canDownload"
      class="download"
      name="download"
      title="Download text file"
      size="24"
      (click)="downloadTextAsFile(text)"
    ></studio-icon>
  </div>
</div>
<ng-content></ng-content>
